<script lang="ts">
    import { Splide, SplideSlide, SplideTrack } from "@splidejs/svelte-splide"
    import "@splidejs/svelte-splide/css"
    import HowItWorksSliderSlide from "./HowItWorksSlider_Slide.svelte"
    import { apiBaseOverride } from "../../store"

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase

    export let block: ContentBlockEntry

    let main: Splide
</script>

<div data-num-slides="{block.howItWorksSlider?.slides?.length}">
    <Splide
        hasTrack="{false}"
        options="{{
            pagination: false,
            arrows: false,
            rewind: true,
        }}"
        aria-label="..."
        bind:this="{main}"
    >
        <SplideTrack>
            {#each block.howItWorksSlider?.slides || [] as slide}
                <SplideSlide>
                    <HowItWorksSliderSlide {apiBase} {slide} {main} />
                </SplideSlide>
            {/each}
        </SplideTrack>
    </Splide>
</div>
